import classNames from "classnames";
import React, { type VideoHTMLAttributes, useMemo } from "react";

interface IProps extends VideoHTMLAttributes<HTMLVideoElement> {
  src: string;
  width?: number;
  height?: number;
  className?: string;
  poster?: string;
}

export default function Video({ src, width, height, poster, className, ...props }: IProps) {
  // true: 가로가 길고 / false: 세로가 김
  const isHorizontal = useMemo(() => (width || 1920) >= (height || 1080), [width, height]);

  return (
    <video
      autoPlay
      className={classNames("", isHorizontal ? "w-full" : "h-full", className)}
      draggable={false}
      height={height}
      key={src}
      loop
      muted
      playsInline
      poster={poster}
      style={{ aspectRatio: `${width} / ${height}` }}
      width={width}
      {...props}
    >
      <source src={src} />
    </video>
  );
}
